var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_804",
    "data-name": "Group 804",
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.719,
    height: 69.258,
    viewBox: "0 0 66.719 69.258",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M79.019,20.179c-9.515,7.588-21.8,24.33-28.667,39.146l-3.011,6.625-4.7-9.274c-4.577-9.034-4.818-9.274-7.347-7.588-1.445.964-5.541,3.493-8.913,5.541C22.891,56.8,20,58.723,20,58.963s2.65,2.048,5.781,4.1c3.252,2.048,9.636,7.709,14.333,12.527l8.552,8.672,4.577-7.227C62.518,62.818,76.61,47.16,84.078,43.185c3.011-1.566,3.132-1.927,1.927-5.42-.723-2.289-.964-7.588-.6-13.249A74.891,74.891,0,0,0,85.885,15C85.764,15,82.633,17.289,79.019,20.179Z",
    transform: "translate(-20 -15)",
    fill: "#3fb254"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.8957d8a2b6ea9c789c3152dbe9fd7d04.svg";
export { ForwardRef as ReactComponent };